var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3300 2463.4",
    style: {
      enableBackground: "new 0 0 3300 2463.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(15.000000000000002) translate(10, 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1012",
    transform: "matrix(0.22321428571428573,0,0,0.22321428571428573,42.857142857142854,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452.3,291.6l-298.4,180c-2.7,2.2-6.1,3.5-9.9,3.5c-8.8,0-16-7.2-16-16c0-6,3.4-11.3,8.4-14l299.4-182 c1.6-1,3.2-2.2,4.6-3.7c10.2-10.2,10.2-26.6,0-36.8c-1.6-1.6-3.3-2.9-5.2-4l-326-198.2c-4.3-2.2-9-3.5-14.1-3.5 C77.9,17.1,64,31,64,48.1V393c0,8.8-7.2,16-16,16s-16-7.2-16-16V47.5C32,13,59.9-14.9,94.4-14.9c11.3,0,21.9,3.1,31,8.3 l326.8,197.1c16.7,10.6,27.8,29.3,27.8,50.6C480,262.3,468.9,280.9,452.3,291.6L452.3,291.6z M80,465.1c8.8,0,16,7.2,16,16 c0,8.8-7.2,16-16,16s-16-7.2-16-16C64,472.2,71.2,465.1,80,465.1L80,465.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/WhiteLogo.f9a4107b10e21c75e6a2af4635cbc056.svg";
export { ForwardRef as ReactComponent };